import React, { useEffect, useState } from "react";
import useIsMobile from "../utils/useIsMobile";
import "./Schedule.css";

const PDF_PATH = "/files/TEDxSetapak_23AUG2025_EventSchedule.pdf";
const EBOOKLET_PATH = "/files/TEDxSetapak-MINES_23Aug2025.pdf";

const Schedule = () => {
  const isMobile = useIsMobile();
  const [scheduleItems, setScheduleItems] = useState([]);

  useEffect(() => {
    fetch("/data/schedule.json")
      .then((res) => res.json())
      .then((data) => setScheduleItems(data))
      .catch((err) => console.error("Failed to load schedule", err));
  }, []);

  return (
    <section id="schedule" className="schedule-container">
      <div className="schedule-header">
        <h2 className="schedule-title">Event Schedule</h2>
<div className="d-flex flex-wrap justify-content-center gap-2 mb-3">
  <a
    href={PDF_PATH}
    target="_blank"
    rel="noopener noreferrer"
    className="btn btn-outline-light btn-sm"
  >
    View PDF
  </a>
  <a
    href={PDF_PATH}
    download="TEDxSetapak_23AUG2025_EventSchedule.pdf"
    className="btn btn-outline-light btn-sm"
  >
    Download PDF
  </a>
  <a
    href={EBOOKLET_PATH}
    download="TEDxSetapak-MINES_23Aug2025.pdf"
    className="btn btn-outline-light btn-sm"
  >
    Download E-Booklet
  </a>
</div>
      </div>

      {isMobile ? (
        <div className="mobile-schedule">
          {scheduleItems.map((item, index) => (
            <div key={index} className="mobile-schedule-item">
              <div className="time">{item.time}</div>
              <div className="title">{item.title}</div>
              <hr className="divider" />
            </div>
          ))}
        </div>
      ) : (
        <>
          <div className="timeline-line" />
          <div className="timeline">
            <div className="timeline-grid">
              {scheduleItems.map((item, index) => (
                <div key={index} className="timeline-row">
                  {index % 2 === 0 ? (
                    <>
                      <div className="timeline-content right-align">
                        <p className="timeline-time">{item.time}</p>
                        <p className="timeline-title">{item.title}</p>
                      </div>
                      <div className="timeline-number">{index + 1}</div>
                      <div className="timeline-empty" />
                    </>
                  ) : (
                    <>
                      <div className="timeline-empty" />
                      <div className="timeline-number">{index + 1}</div>
                      <div className="timeline-content left-align">
                        <p className="timeline-time">{item.time}</p>
                        <p className="timeline-title">{item.title}</p>
                      </div>
                    </>
                  )}
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </section>
  );
};

export default Schedule;
